module.exports = __webpack_public_path__ + "img/img_046@2x.a11a3da7.png";